import PropTypes from 'prop-types';
import React from 'react';
import { Grid } from 'semantic-ui-react';

import Container from '../../layout/Container';
import ValueItem from './ValueItem';
import { translateLocal } from '../../../i18n';

import './ValuesBlock.scss';

const ValuesBlock = ({ items }) => (
  <div className="values-block">
    <Container>
      <Grid columns={3} stackable>
        <Grid.Row>
          {items.map((item, index) => (
            <Grid.Column key={index}>
              <ValueItem
                icon={item.icon}
                title={translateLocal(item.title)}
                description={translateLocal(item.description)}
              />
            </Grid.Column>
          ))}
        </Grid.Row>
      </Grid>
    </Container>
  </div>
);

ValuesBlock.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.string,
      title: PropTypes.object,
      description: PropTypes.object,
    }),
  ).isRequired,
};

export default ValuesBlock;
